import React, { Dispatch } from 'react';
import { ILedgerQueryParams } from '../type';
import { IPageInfo } from '../../../components/OATableComponent';

export interface ILedgerContext {
  ledgerList: any[];
  internalLedgerList: any;
  supplierTransactionsList: any;
  pageInfo: IPageInfo;
  getLedgerInfo: (cb?: ((response?: any) => void) | undefined) => Promise<void>;
  getLedgerList: (cb?: ((response?: any) => void) | undefined) => Promise<void>;
  getInternalLedgerEntryList: (cb?: ((response?: any) => void) | undefined) => Promise<void>;
  getSupplierTransactions: (cb?: ((response?: any) => void) | undefined) => Promise<void>;
  ledgerBalance: any;
  getCurrentBalance: (cb?: ((response?: any) => void) | undefined) => Promise<void>;
  downloadReport: (cb?: ((response?: any) => void) | undefined) => Promise<void>;
  downloadInternalLedgerReport: (cb?: ((response?: any) => void) | undefined) => Promise<void>;
  addBalance: (amount: number, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  addTransaction: (values: any, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  editTransaction: (values: any, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  addTopupSettlement: (values: any, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  addTopup: (values: any, cb?: ((response?: any) => void) | undefined) => Promise<void>;
  uploadSettlementCsv: (formData: FormData, paymentMethod?: string, cb?: ((response?: any) => void) | undefined) => Promise<void>;
}

const LedgerContext = React.createContext<ILedgerContext>({} as ILedgerContext);

export default LedgerContext;